// extracted by mini-css-extract-plugin
export default {"a0":"zVpHkXJNFUJvIRE6Z3Qp","a1":"A2iDIT8CFjQUvYeP4Cc_","cls1":"CL4KiiE7kFSQFyJCoJqZ","cls2":"d3K6FYW0yH16GEhCcsIj CL4KiiE7kFSQFyJCoJqZ"};